import React from 'react';
import { IWithReactRouterProps, withReactRouter } from '../../mixins/router/withReactRouter';

import { ITranslateProps, translate } from '../../mixins/translate';
import { fetchDelete, fetchGet } from '../../store/fetch';
import { IconEditButton } from '../common/iconButtons/IconEditButton';
import { IconRemoveButton } from '../common/iconButtons/IconRemoveButton';
import { Table, TableBody, TableButtons, TableData, TableHead, TableHeader, TableHeadRow, TableRow } from '../elements';
import { ComponentSetStatePromised } from '../utils/ComponentSetStatePromised';
import { NullableBoolean } from '../utils/NullableBoolean';
import { NullableFormattedDate } from '../utils/NullableFormattedDate';

interface ILicencesListProps extends ITranslateProps, IWithReactRouterProps {
    companyId: string;
}

interface ILicence {
    id: string;
    name: string;
    activatedOnDate: string;
    expiresOnDate: string;
    isInUseByDeviceName: string;
    isStandalone: boolean;
    activatedBy: string;
}

interface ILicencesListState {
    items: ILicence[];
}

class LicencesList extends ComponentSetStatePromised<ILicencesListProps, ILicencesListState> {
    constructor(props: ILicencesListProps) {
        super(props);

        this.state = {
            items: [],
        };
    }

    public override async componentDidMount() {
        await this.load();
    }

    public override render() {
        return (
            <Table>
                <TableHead>
                    <TableHeadRow light={true}>
                        <TableHeader>{this.props.t('common.name')}</TableHeader>
                        <TableHeader>{this.props.t('licence.activatedOnDate')}</TableHeader>
                        <TableHeader>{this.props.t('licence.expiresOnDate')}</TableHeader>
                        <TableHeader>{this.props.t('licence.deviceName')}</TableHeader>
                        <TableHeader>{this.props.t('licence.isStandalone')}</TableHeader>
                        <TableHeader>{this.props.t('licence.activatedBy')}</TableHeader>
                        <TableHeader>&nbsp; </TableHeader>
                    </TableHeadRow>
                </TableHead>
                <TableBody>
                    {this.state.items.map((item) => (
                        <TableRow key={item.id}>
                            <TableData>{item.name}</TableData>
                            <TableData>
                                <NullableFormattedDate value={item.activatedOnDate} />{' '}
                            </TableData>
                            <TableData>
                                <NullableFormattedDate value={item.expiresOnDate} />{' '}
                            </TableData>
                            <TableData>{item.isInUseByDeviceName}</TableData>
                            <TableData>
                                <NullableBoolean value={item.isStandalone} />
                            </TableData>
                            <TableData>{item.activatedBy}</TableData>
                            <TableButtons>
                                <IconEditButton onClick={() => this.edit(item.id)} />
                                <IconRemoveButton
                                    removeQuestion={this.props.t('common.confirmDelete', `${item.name} `)}
                                    onClick={async () => this.remove(item.id)}
                                />
                            </TableButtons>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    private async load() {
        const result = await fetchGet(`/api/companies/${this.props.companyId}/licences`, { limit: '100', offset: '0' });
        await this.setStatePromised({ items: result.json.items });
    }

    private async remove(id: string) {
        await fetchDelete(`/api/companies/${this.props.companyId}/licences/${id}`);
        await this.load();
    }

    private edit(id: string) {
        this.props.navigate(`/companies/addlicence/?companyId=${this.props.companyId}&licenceId=${id}`);
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(withReactRouter(LicencesList));
